import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            {contactData.desc}
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-stretch justify-center gap-4 md:gap-6 max-w-3xl mx-auto">
          {contactData.items.map((item) => (
            <div
              key={item.label}
              className="flex-1 bg-background-50 rounded-xl p-6 flex flex-col items-center text-center gap-3"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-full">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800">{item.label}</h3>
              <p className="text-sm text-foreground-600 font-medium">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}